var _path, _path2, _path3, _path4, _path5, _ellipse, _rect, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 50,
    viewBox: "0 0 57 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.209 15.3663C40.209 17.2187 39.5751 18.79 38.3073 20.0801C37.0558 21.3536 35.5199 21.9904 33.6995 21.9904C32.5292 21.9904 31.4483 21.7009 30.4569 21.122V28.7385H27.1655V15.3663C27.1655 13.4973 27.7913 11.9261 29.0428 10.6525C30.3106 9.37896 31.8628 8.74219 33.6995 8.74219C35.5199 8.74219 37.0558 9.38723 38.3073 10.6773C39.5751 11.9509 40.209 13.5138 40.209 15.3663ZM36.9177 15.3663C36.9177 14.4566 36.6007 13.6875 35.9668 13.059C35.3492 12.414 34.5934 12.0914 33.6995 12.0914C32.8055 12.0914 32.0416 12.414 31.4077 13.059C30.7738 13.6875 30.4569 14.4566 30.4569 15.3663C30.4569 16.276 30.7738 17.0533 31.4077 17.6984C32.0416 18.3269 32.8055 18.6411 33.6995 18.6411C34.5934 18.6411 35.3492 18.3269 35.9668 17.6984C36.6007 17.0533 36.9177 16.276 36.9177 15.3663Z",
    fill: "#30D5C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.678 14.4132C26.678 14.7439 26.6536 15.0747 26.6049 15.4055H17.0721C17.2834 16.1002 17.6735 16.6625 18.2424 17.0926C18.8113 17.5061 19.4533 17.7128 20.1685 17.7128C21.1599 17.7128 21.9807 17.3241 22.6309 16.5468L24.6301 19.251C23.3785 20.4584 21.8913 21.0621 20.1685 21.0621C18.3318 21.0621 16.7796 20.4253 15.5118 19.1517C14.2603 17.8617 13.6345 16.2821 13.6345 14.4132C13.6345 12.5607 14.2684 10.9977 15.5362 9.72419C16.804 8.4341 18.3481 7.78906 20.1685 7.78906C21.9888 7.78906 23.5248 8.4341 24.7763 9.72419C26.0441 10.9977 26.678 12.5607 26.678 14.4132ZM22.9966 12.8998C22.3952 11.7255 21.4525 11.1383 20.1685 11.1383C18.8682 11.1383 17.9173 11.7255 17.316 12.8998H22.9966Z",
    fill: "#30D5C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0435 14.4366C13.0435 16.289 12.4096 17.8603 11.1418 19.1504C9.89029 20.4239 8.35433 21.0607 6.53393 21.0607C5.36367 21.0607 4.28281 20.7712 3.29134 20.1924V27.8088H0V14.4366C0 12.5676 0.625761 10.9964 1.87728 9.72282C3.14506 8.44927 4.69728 7.8125 6.53393 7.8125C8.35433 7.8125 9.89029 8.45754 11.1418 9.74763C12.4096 11.0212 13.0435 12.5842 13.0435 14.4366ZM9.75213 14.4366C9.75213 13.5269 9.43519 12.7578 8.8013 12.1293C8.18366 11.4843 7.42788 11.1618 6.53393 11.1618C5.63998 11.1618 4.87607 11.4843 4.24218 12.1293C3.60829 12.7578 3.29134 13.5269 3.29134 14.4366C3.29134 15.3463 3.60829 16.1236 4.24218 16.7687C4.87607 17.3972 5.63998 17.7114 6.53393 17.7114C7.42788 17.7114 8.18366 17.3972 8.8013 16.7687C9.43519 16.1236 9.75213 15.3463 9.75213 14.4366Z",
    fill: "#30D5C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9881 22.5709H40.6968V2.92188H43.9881V22.5709Z",
    fill: "#30D5C8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6472 22.5704L48.6472 11.4062L45.0048 11.4063L45.0048 22.5704L48.6472 22.5704Z",
    fill: "#30D5C8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.70662,
    cy: 1.73665,
    rx: 1.70662,
    ry: 1.73665,
    transform: "matrix(-1 8.8961e-08 8.59111e-08 1 48.5327 6.96094)",
    fill: "#FFEB4A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.7837,
    y: 0.232945,
    width: 5.97621,
    height: 6.08792,
    rx: 2.98811,
    stroke: "#30D5C8",
    strokeWidth: 0.37214
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7415 4.06187V2.49219H53.9558L54.5922 3.51036H54.4694L55.1035 2.49219H55.3178V4.06187H55.0164V3.01244L55.0745 3.0303L54.6324 3.74034H54.4269L53.9848 3.0303L54.0451 3.01244V4.06187H53.7415Z",
    fill: "#30D5C8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7257 4.06187V2.52568H53.0316V4.06187H52.7257ZM52.2256 2.76236V2.49219H53.5318V2.76236H52.2256Z",
    fill: "#30D5C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.f893fd9dc70873f6b599937648fcae0a.svg";
export { ForwardRef as ReactComponent };